export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`} aria-label="BubbleTrace home">
      <span className="brand-mark" aria-hidden="true">
        <span className="brand-orbit brand-orbit--one" />
        <span className="brand-orbit brand-orbit--two" />
        <span className="brand-core" />
      </span>
      {!compact && (
        <span className="brand-word">
          bubble<span>trace</span>
        </span>
      )}
    </div>
  );
}
